/**
 * Utility functions for generating subdomain URLs
 */

/**
 * Check if we're in development environment (using lvh.me)
 */
export const isDevelopment = (): boolean => {
  return (
    typeof window !== 'undefined' && window.location.hostname.includes('lvh.me')
  );
};

/**
 * Get the base domain and port for current environment
 */
export const getBaseDomain = (): string => {
  if (typeof window === 'undefined') return '';

  const port = window.location.port;
  const portString = port ? `:${port}` : '';

  return isDevelopment() ? `lvh.me${portString}` : 'agile-x.io';
};

/**
 * Generate subdomain URL for different parts of the application
 */
export const getSubdomainUrl = (
  subdomain: string = '',
  path: string = ''
): string => {
  if (typeof window === 'undefined') return path;

  const protocol = window.location.protocol;
  const baseDomain = getBaseDomain();
  const domain = subdomain ? `${subdomain}.${baseDomain}` : baseDomain;

  return `${protocol}//${domain}${path}`;
};

/**
 * Convenience functions for specific subdomains
 */
export const marketingUrl = (path: string = ''): string =>
  getSubdomainUrl('', path);
export const appUrl = (path: string = ''): string =>
  getSubdomainUrl('app', path);
export const adminUrl = (path: string = ''): string =>
  getSubdomainUrl('admin', path);
export const authUrl = (): string => appUrl('/auth/login');
